export default __webpack_public_path__ + "static/media/doctor4.1efcaae7.jpg";